import { Pipe, PipeTransform } from '@angular/core';
import { CommonDataSetAction, ItemAttrListDataSet } from '@mri/types';

@Pipe({
  name: 'tableDataSetLink'
})
export class TableDataSetLinkPipe implements PipeTransform {

  transform(actions: CommonDataSetAction, prop: ItemAttrListDataSet): string[] | null {
    if (typeof actions.link === 'function') return actions.link(prop);

    return actions.link || [];
  }

}
